import { Serializer } from '@junte/serialize-ts';

export class NumberSerializer implements Serializer<number> {
  public deserialize(dto: string): number {
    return parseFloat(dto);
  }

  public serialize(model: number): string {
    return model.toString();
  }
}

/** Accepts client company FK (number) or client uid (string) for keep-private Direct Deals. */
export class ClientCompanySerializer implements Serializer<string | number | null> {
  public deserialize(dto: string | number | Record<string, unknown> | null | undefined): string | number | null {
    if (dto === null || dto === undefined || dto === '') {
      return null;
    }
    if (typeof dto === 'number') {
      return dto;
    }
    if (typeof dto === 'object') {
      const record = dto as Record<string, unknown>;
      if (record['uid'] != null && record['uid'] !== '') {
        return String(record['uid']);
      }
      if (record['id'] != null && record['id'] !== '') {
        const id = record['id'];
        return typeof id === 'number' ? id : /^\d+$/.test(String(id)) ? parseInt(String(id), 10) : String(id);
      }
      return null;
    }
    const raw = String(dto).trim();
    if (!raw) {
      return null;
    }
    if (/^\d+$/.test(raw)) {
      return parseInt(raw, 10);
    }
    return raw;
  }

  public serialize(model: string | number | null | undefined): string | number | null {
    if (model === null || model === undefined || model === '') {
      return null;
    }
    return model;
  }
}
